import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[100dvh] bg-gradient-to-b from-white via-slate-50 to-slate-100 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 text-center px-4 sm:px-6">
            {/* Logo */}
            <div className="mb-8 sm:mb-10">
                <img
                    src="/konaspi.png"
                    alt="Event Logo"
                    className="h-14 sm:h-16 mx-auto mb-3"
                />
                <h1 className="text-base sm:text-lg font-semibold tracking-wide text-gray-600 dark:text-gray-300 uppercase">
                    KONASPI XII
                </h1>
            </div>

            {/* 404 */}
            <h1 className="text-[6rem] sm:text-[8rem] leading-none font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-500 mb-4 sm:mb-6">
                404
            </h1>

            {/* Main text */}
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-gray-100 mb-2 sm:mb-3">
                Page Not Found
            </h2>
            <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 max-w-xs sm:max-w-md mb-8">
                Sorry, the page you’re looking for doesn’t exist or may have been moved.
                Please return to the homepage to continue exploring.
            </p>

            {/* Button */}
            <Button
                onClick={() => navigate("/")}
                className="flex items-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base rounded-full font-medium shadow-sm hover:shadow-md transition-all"
            >
                <Home className="w-4 h-4 sm:w-5 sm:h-5" />
                Back to Home
            </Button>

            {/* Footer */}
            <p className="mt-10 sm:mt-12 text-[11px] sm:text-xs text-gray-500 dark:text-gray-500">
                © {new Date().getFullYear()} KONASPI XII — All Rights Reserved
            </p>
        </div>
    );
};

export default NotFound;
